export default "__VITE_ASSET__CG9OX5j___"